import {Presenter} from '../../../../Support/with_presenter';
import {NetworkResult} from '../../../../Network/NetworkResult';
import {SnippetInput, SnippetService} from '../../../../Network/SnippetService';
import {FullWorkout} from '../../../../Models/FullWorkout';
import {FullWorkoutStatisticProvider} from '../../../../Business/FulllWorkoutStatisticProvider';
import {loadingResponse} from '../../../../Network/NetworkResult';
import {Report} from '../../../../Models/Report';
import {ReportService} from '../../../../Network/ReportService';
import {LocalPreferences} from '../../../../Persistence/LocalPreferences';
import {RangeInput} from '../../../../Models/RangeInput';
import {RangeOverview} from '../../../../Strokes/calculateRangeOverview';

export class SaveSnippetPresenter implements Presenter {
    public reports: NetworkResult<Report[]> = loadingResponse();

    public selectedReport: Report | null = null;

    public disabledForm: boolean = true;

    constructor(
        private fullWorkout: FullWorkout,
        private snippetService: SnippetService,
        private reportService: ReportService,
        private localPreferences: LocalPreferences,
    ) {}

    public async mount(): Promise<void> {
        this.reports = await this.reportService.all();
        if (this.localPreferences.has('selected-report-id') && this.reports.status === 'success') {
            const selectedReport = this.localPreferences.get('selected-report-id');
            this.selectedReport = this.reports.data.find((report) => report.id === selectedReport) ?? null;
        }
        this.checkForm();
    }

    public unmount(): void {
        /* Noop */
    }

    public setSelectedReport(report: Report): void {
        this.selectedReport = report;
        this.localPreferences.set('selected-report-id', report.id);
        this.checkForm();
    }

    public checkForm(): void {
        this.disabledForm = this.selectedReport === null;
    }

    public async onSubmit(
        input: RangeInput,
        overview: RangeOverview,
    ): Promise<
        NetworkResult<{
            id: number;
        }>
    > {
        const snippet: SnippetInput = {
            workoutId: this.fullWorkout.id,
            reportId: Number(this.selectedReport?.id) ?? null,
            startTimeMillis: Math.round(input.start.milliseconds),
            endTimeMillis: Math.round(input.end.milliseconds),
            elapsedTimeMillis: overview.totalDuration.milliseconds,
            traveledDistanceMillimeters: overview.totalDistance.millimeters,
            averagePowerWatts: overview.averagePower?.watts ?? null,
            averageRelativePeakForcePosition: overview.relativePeakForcePosition?.value ?? null,
            averageSplitMillis: overview.averageSpeed?.durationPer500Meters?.milliseconds ?? null,
            averagePeakForce: overview.averagePeakForce?.newton ?? null,
            averageStrokeLengthMillimeters: overview.averageStrokeLength?.millimeters ?? null,
            averageDriveTimeMillis: overview.averageDriveTime?.milliseconds ?? null,
            averageRecoverTimeMillis: overview.averageRecoverTime?.milliseconds ?? null,
            averageEnergyPerStroke: overview.averageEnergyPerStroke?.joules ?? null,
        };
        return await this.snippetService.createForReport(snippet);
    }
}
